import LegalLayout from '../components/legal/LegalLayout.jsx';

const TOC = [
  { id: 'responsable', label: '1. Responsable del tratamiento' },
  { id: 'datos', label: '2. Qué datos recogemos' },
  { id: 'finalidad', label: '3. Para qué los usamos' },
  { id: 'legitimacion', label: '4. Base legal' },
  { id: 'conservacion', label: '5. Cuánto tiempo los guardamos' },
  { id: 'destinatarios', label: '6. Con quién los compartimos' },
  { id: 'transferencias', label: '7. Transferencias internacionales' },
  { id: 'derechos', label: '8. Tus derechos' },
  { id: 'cookies', label: '9. Cookies' },
  { id: 'seguridad', label: '10. Seguridad' },
  { id: 'menores', label: '11. Menores' },
  { id: 'cambios', label: '12. Cambios' },
  { id: 'contacto', label: '13. Contacto' },
];

export default function PrivacidadPage() {
  return (
    <LegalLayout
      title="Política de Privacidad"
      intro="Aquí explicamos qué datos tuyos recogemos, para qué los usamos, cuánto tiempo los guardamos y cómo puedes ejercer tus derechos. En lenguaje claro, sin letra pequeña."
      meta={[
        { label: 'Última actualización', value: '29 de abril de 2026' },
        { label: 'Versión', value: '1.0' },
        { label: 'Vigencia', value: 'Inmediata' },
      ]}
      toc={TOC}
    >
      <div className="legal-callout">
        <strong>Resumen rápido:</strong> Random College recoge tu email cuando te registras, lo usa
        para enviarte información sobre el programa y para contactarte si nos escribes. No
        vendemos tus datos a nadie. Puedes pedir que los borremos en cualquier momento escribiéndonos
        a <a href="mailto:hola@randomcollege.com">hola@randomcollege.com</a>.
      </div>

      <h2 id="responsable">1. Responsable del tratamiento</h2>
      <p>
        Esta web es propiedad de <strong>Random College</strong>. Los datos que se recogen a través
        de este sitio son tratados por:
      </p>
      <ul>
        <li>
          <strong>Titular:</strong> [Razón social pendiente de completar]
        </li>
        <li>
          <strong>NIF/CIF:</strong> [Pendiente]
        </li>
        <li>
          <strong>Domicilio:</strong> [Pendiente, Madrid, España]
        </li>
        <li>
          <strong>Email de contacto:</strong>{' '}
          <a href="mailto:hola@randomcollege.com">hola@randomcollege.com</a>
        </li>
        <li>
          <strong>Delegado de Protección de Datos:</strong> [DPO si aplica]
        </li>
      </ul>

      <h2 id="datos">2. Qué datos recogemos</h2>
      <p>
        Recogemos únicamente los datos estrictamente necesarios para prestarte el servicio o
        responder a tus consultas. Concretamente:
      </p>
      <table className="legal-table">
        <thead>
          <tr>
            <th>Cuándo lo recogemos</th>
            <th>Qué datos</th>
            <th>Obligatorio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Formulario de contacto</td>
            <td>Nombre, email, asunto, mensaje</td>
            <td>Nombre y email</td>
          </tr>
          <tr>
            <td>Suscripción a la lista (Coming Soon)</td>
            <td>Email</td>
            <td>Sí</td>
          </tr>
          <tr>
            <td>Navegación por la web</td>
            <td>IP, navegador, páginas visitadas, dispositivo</td>
            <td>Recogidos automáticamente</td>
          </tr>
          <tr>
            <td>Cookies analíticas y de marketing</td>
            <td>Datos de comportamiento agregados</td>
            <td>Solo si aceptas</td>
          </tr>
        </tbody>
      </table>
      <p>
        El proceso de pago y el acceso a la formación se gestionan a través de{' '}
        <strong>Skool</strong>. La gestión de tus datos en Skool se rige por su propia política de
        privacidad, disponible en{' '}
        <a href="https://www.skool.com/privacy" target="_blank" rel="noopener noreferrer">
          skool.com/privacy
        </a>
        .
      </p>

      <h2 id="finalidad">3. Para qué los usamos</h2>
      <p>Tratamos tus datos exclusivamente para los siguientes fines:</p>
      <ul>
        <li>
          <strong>Atender tu solicitud</strong>: si nos escribes a través del formulario, usamos tu
          email y nombre para responderte.
        </li>
        <li>
          <strong>Enviarte información</strong> sobre el lanzamiento y novedades del programa, solo
          si te has suscrito.
        </li>
        <li>
          <strong>Mejorar la web</strong>: analizar de forma agregada cómo se usa el sitio para
          optimizar la experiencia (con cookies analíticas, solo si las aceptas).
        </li>
        <li>
          <strong>Cumplir obligaciones legales</strong>: facturación, contabilidad, requerimientos
          de autoridades competentes.
        </li>
      </ul>
      <p>
        No usamos tus datos para perfilado automatizado ni para tomar decisiones que produzcan
        efectos jurídicos sobre ti.
      </p>

      <h2 id="legitimacion">4. Base legal del tratamiento</h2>
      <p>
        El tratamiento de tus datos se ampara en las siguientes bases legales del Reglamento
        General de Protección de Datos (RGPD):
      </p>
      <ul>
        <li>
          <strong>Consentimiento</strong> (Art. 6.1.a RGPD): cuando te suscribes a nuestra lista o
          aceptas cookies no esenciales.
        </li>
        <li>
          <strong>Interés legítimo</strong> (Art. 6.1.f RGPD): para responder a tus consultas y
          para cookies estrictamente técnicas.
        </li>
        <li>
          <strong>Obligación legal</strong> (Art. 6.1.c RGPD): para cumplir con la normativa
          fiscal, contable y de protección de datos.
        </li>
      </ul>

      <h2 id="conservacion">5. Cuánto tiempo guardamos tus datos</h2>
      <ul>
        <li>
          <strong>Datos de contacto</strong>: hasta que solicites su eliminación o durante un
          máximo de 3 años desde la última interacción.
        </li>
        <li>
          <strong>Datos de suscripción</strong>: hasta que te des de baja (cada email incluye un
          enlace para hacerlo en un click).
        </li>
        <li>
          <strong>Datos fiscales y contables</strong>: durante los plazos legalmente exigidos
          (mínimo 6 años en España).
        </li>
        <li>
          <strong>Cookies</strong>: ver sección específica de cookies.
        </li>
      </ul>

      <h2 id="destinatarios">6. Con quién compartimos tus datos</h2>
      <p>
        No vendemos, alquilamos ni cedemos tus datos a terceros con fines comerciales. Solo los
        compartimos con proveedores que nos prestan servicios necesarios para operar la web:
      </p>
      <ul>
        <li>
          <strong>Proveedor de hosting</strong>: [Webflow / proveedor pendiente] para alojar el
          sitio.
        </li>
        <li>
          <strong>Proveedor de email marketing</strong>: [Mailchimp / ConvertKit / pendiente] para
          gestionar la lista de suscriptores.
        </li>
        <li>
          <strong>Skool</strong>: para gestionar el acceso al programa de formación.
        </li>
        <li>
          <strong>Google Analytics</strong>: solo si aceptas cookies analíticas, para medir el uso
          del sitio.
        </li>
        <li>
          <strong>Autoridades competentes</strong>: cuando exista obligación legal.
        </li>
      </ul>

      <h2 id="transferencias">7. Transferencias internacionales</h2>
      <p>
        Algunos de nuestros proveedores (como Skool, Google o Mailchimp) están ubicados en Estados
        Unidos. Estas transferencias se realizan amparadas en mecanismos legales válidos según el
        RGPD: Cláusulas Contractuales Tipo aprobadas por la Comisión Europea o adhesión al marco{' '}
        <em>EU-US Data Privacy Framework</em>.
      </p>

      <h2 id="derechos">8. Tus derechos</h2>
      <p>Como titular de los datos, puedes ejercer en cualquier momento los siguientes derechos:</p>
      <ul>
        <li>
          <strong>Acceso</strong>: saber qué datos tuyos tenemos.
        </li>
        <li>
          <strong>Rectificación</strong>: corregir datos inexactos o incompletos.
        </li>
        <li>
          <strong>Supresión</strong> (“derecho al olvido”): eliminar tus datos cuando ya no sean
          necesarios.
        </li>
        <li>
          <strong>Oposición</strong>: oponerte al tratamiento de tus datos para ciertas finalidades.
        </li>
        <li>
          <strong>Limitación</strong>: pedir que se limite el tratamiento mientras se resuelve una
          reclamación.
        </li>
        <li>
          <strong>Portabilidad</strong>: recibir tus datos en un formato estructurado y reutilizable.
        </li>
        <li>
          <strong>Retirar el consentimiento</strong> en cualquier momento, sin que afecte a los
          tratamientos previos.
        </li>
      </ul>
      <p>
        Para ejercer cualquiera de estos derechos, escríbenos a{' '}
        <a href="mailto:hola@randomcollege.com">hola@randomcollege.com</a> indicando el derecho que
        quieres ejercer y adjuntando una copia de tu DNI o documento equivalente para verificar tu
        identidad. Te responderemos en un plazo máximo de un mes.
      </p>
      <p>
        Si consideras que no hemos atendido correctamente tu solicitud, puedes presentar una
        reclamación ante la <strong>Agencia Española de Protección de Datos</strong> (
        <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">
          www.aepd.es
        </a>
        ).
      </p>

      <h2 id="cookies">9. Cookies</h2>
      <p>
        Esta web utiliza cookies para mejorar tu experiencia y analizar el uso del sitio.
        Distinguimos tres tipos:
      </p>
      <ul>
        <li>
          <strong>Cookies técnicas</strong> (siempre activas): necesarias para que la web funcione
          (preferencia de tema claro/oscuro, idioma).
        </li>
        <li>
          <strong>Cookies analíticas</strong> (opcionales): nos ayudan a entender cómo se usa el
          sitio. Solo se activan si las aceptas.
        </li>
        <li>
          <strong>Cookies de marketing</strong> (opcionales): para mostrarte publicidad relevante en
          otras plataformas. Solo se activan si las aceptas.
        </li>
      </ul>
      <p>
        Puedes gestionar tus preferencias de cookies en cualquier momento desde el banner de
        cookies o desde la configuración de tu navegador.
      </p>

      <h2 id="seguridad">10. Seguridad</h2>
      <p>
        Aplicamos medidas técnicas y organizativas razonables para proteger tus datos frente a
        accesos no autorizados, pérdida, alteración o divulgación. Entre ellas: cifrado HTTPS en
        toda la web, acceso restringido a los datos solo para personal autorizado, y revisión
        periódica de nuestras prácticas de seguridad.
      </p>
      <p>
        Aun así, ningún sistema es 100 % seguro. Si detectamos una brecha que pueda afectar a tus
        datos, te lo notificaremos en un plazo máximo de 72 horas según exige la normativa.
      </p>

      <h2 id="menores">11. Menores de edad</h2>
      <p>
        Esta web y el programa Random College están dirigidos a personas mayores de 18 años. No
        recogemos datos de menores de edad de forma consciente. Si eres padre o tutor y crees que
        un menor a tu cargo nos ha facilitado datos sin tu consentimiento, escríbenos y los
        eliminaremos de inmediato.
      </p>

      <h2 id="cambios">12. Cambios en esta política</h2>
      <p>
        Podemos actualizar esta política para reflejar cambios legales, tecnológicos o en nuestros
        servicios. Cuando hagamos cambios significativos, te lo notificaremos por email (si estás
        suscrito) o mediante un aviso destacado en la web. La fecha de última actualización siempre
        se muestra al principio de este documento.
      </p>

      <h2 id="contacto">13. Contacto</h2>
      <p>
        Si tienes cualquier duda sobre esta Política de Privacidad o sobre el tratamiento de tus
        datos, escríbenos:
      </p>
      <ul>
        <li>
          <strong>Email</strong>: <a href="mailto:hola@randomcollege.com">hola@randomcollege.com</a>
        </li>
        <li>
          <strong>Asunto sugerido</strong>: “Privacidad — [tu consulta]”
        </li>
        <li>
          <strong>Tiempo medio de respuesta</strong>: menos de 48 horas laborables
        </li>
      </ul>

      <div className="legal-callout" style={{ marginTop: 48 }}>
        <strong>Aviso:</strong> Esta política es una plantilla base que necesita ser revisada y
        completada con los datos legales reales de Random College (razón social, NIF, domicilio,
        proveedores específicos contratados) antes de publicarse. Recomendamos encarecidamente que
        un abogado especializado en protección de datos revise el documento final antes de su
        entrada en vigor.
      </div>
    </LegalLayout>
  );
}
